const blueLocation = (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="30" height="30" rx="7.5" fill="#F3FAFB"/>
    <path d="M19.5 13.9999C19.5 17.4999 15 20.4999 15 20.4999C15 20.4999 10.5 17.4999 10.5 13.9999C10.5 12.8064 10.9741 11.6618 11.818 10.8179C12.6619 9.97398 13.8065 9.49988 15 9.49988C16.1935 9.49988 17.3381 9.97398 18.182 10.8179C19.0259 11.6618 19.5 12.8064 19.5 13.9999Z" stroke="#159FB4" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 15.4999C15.8284 15.4999 16.5 14.8283 16.5 13.9999C16.5 13.1715 15.8284 12.4999 15 12.4999C14.1716 12.4999 13.5 13.1715 13.5 13.9999C13.5 14.8283 14.1716 15.4999 15 15.4999Z" stroke="#159FB4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export default blueLocation
